import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-regular fa-file-pdf"
}
const _hoisted_2 = {
  key: 1,
  class: "fa-solid fa-file-csv"
}
const _hoisted_3 = {
  key: 2,
  class: "fa-regular fa-file-excel"
}
const _hoisted_4 = {
  key: 3,
  class: ""
}
const _hoisted_5 = {
  key: 4,
  class: "fa-regular fa-file"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'FileIcon',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (props.type == 'pdf')
    ? (_openBlock(), _createElementBlock("i", _hoisted_1))
    : (props.type == 'csv')
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : (props.type == 'excel')
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (props.type == 'json')
          ? (_openBlock(), _createElementBlock("i", _hoisted_4, "{}"))
          : (_openBlock(), _createElementBlock("i", _hoisted_5))
}
}

})